<script>
import { mapActions, mapGetters } from 'vuex';

import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import Pagination from 'vue-pagination-2';
import ModalForm from '@/components/departments/ModalUserDepartamentComponent.vue';
import ModalTablePays from '@/components/departments/ModalTablePaysComponent.vue'
import ModalContractEnds from '@/components/contracts/ModalContractEndsComponent.vue'
import ModalFormCurrentPayments from '@/components/contracts/ModalFormCurrentPayments.vue';
import ModalTableContractsRelation from '@/components/contracts/ModalTableContractsRelationComponent.vue';

import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';
import ModalFormIncreases from '@/components/contracts_new/ModaFormIncreasesComponent.vue';
import ModalFilesContractsComponent from '@/components/contracts_new/ModalFilesContractsComponent.vue';
import ModalContractEndsDetailComponent from '@/components/contracts/ModalContractEndsDetailComponent.vue';

export default {
    name: "contracts-table",
    components: {
        Pagination,
        ModalFormComponentContracts,
        ModalForm,
        ModalTablePays,
        ModalContractEnds,
        ModalFormCurrentPayments,
        ModalTableContractsRelation,
        ModalFormIncreases,
        ModalFilesContractsComponent,
        ModalContractEndsDetailComponent
    },
    data() {
        return {
            editForm: false,
            load: false,
            catalogue: new Catalogue(),
            page: 1,
            years: Array.from({ length: 20 }, (v, i) => 2020 + i),
            search: {
                search: '',
                building_id: '',
                company_id: '',
                status: 1,
                finish: '',
                user_id: '',
                month: '',
                year: '',
                authorization_user_id: '',
                authorization_status: '',
                user_id_authorization: '',
                payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
            },
            loadCount: false,
            count1: 0,
            count2: 0,
        }
    },
    methods: {
        getUserProfile() {
            let profile = this.search.authorization_user_id;
            if (profile) {
                this.catalogue.get_users_profile(profile);
            }
            this.list();
        },
        showEnds(buy) {
            Event.$emit('event-show-showContractEnds', buy);
        },
        showAddendum(idContract) {
            this.editForm = false;
            Event.$emit('event-show-showContractID', idContract);
        },
        shouldShowAuthorizeButton(contract) {
            const chartId = this.authUser.organization_charts_id;
            const userId = this.authUser.id;

            const roleArrayMap = {
                1: 'user_admin',
                11: 'user_juridical',
                10: 'user_auxiliary'
            };

            const roleKey = roleArrayMap[chartId];

            if (!roleKey || !contract[roleKey]) {
                return false;
            }

            const validator = contract[roleKey].find(v =>
                v.user_id === userId
            );

            return !validator;

        },
        renew(buy) {
            this.editForm = true;
            Event.$emit('event-show-renewContracts', buy);
        },
        addendum(buy) {
            this.editForm = true;
            let addendum = 1;
            Event.$emit('event-show-renewContracts', buy, addendum);
        },
        showFilesContracts(buy) {
            Event.$emit('event-show-addFilesContracts', buy);
        },
        increase(buy) {
            Event.$emit('event-show-addNewIncreasess', buy);
        },
        showNewContracts(contract = false, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addNewContracts', contract);
        },
        showTenantsRelation(tenants) {
            Event.$emit('event-show-ContractsRelation', tenants);
        },
        getDiffDays(buy) {
            console.log('buy');
            console.log(buy);
            let className = '';
            const startDate = this.moment();
            const limitDate = this.moment().add(60, 'days');

            // Por terminar
            const fechaEspecifica = this.moment(buy.end_date);
            const fechaActual = this.moment();
            let dif_days = fechaEspecifica.diff(fechaActual, 'days');
            if (dif_days <= 30) {
                className = 'fa-solid fa-lightbulb mt-3 text-danger fa-xl fa-fade';
            }

            // Falta porcentaje
            let porcentaje = buy.rent_increase.some(increase => {
                const increaseDate = new Date(increase.date);
                return increaseDate >= startDate && increaseDate <= limitDate && increase.check;
            });

            if (porcentaje) {
                className = 'fa-solid fa-lightbulb mt-3 text-warning fa-xl fa-fade';
            }

            // Por incrementar
            let incr = buy.rent_increase.some(increase => {
                const increaseDate = new Date(increase.date);
                return increaseDate >= startDate && increaseDate <= limitDate && !increase.check;
            });

            if (incr) {
                className = 'fa-solid fa-lightbulb mt-3 text-info fa-xl fa-fade';
            }

            // Vencido sin finalizar           
            if (new Date(buy.end_date) < startDate && buy.end_all == null) {
                className = 'fa-solid fa-lightbulb mt-3 text-purple fa-xl fa-fade';
            }

            return className;
        },
        downloadRecibe(id) {
            window.open(this.globalUrlFiles + '/contracts/pdf/' + id, '_blank');
        },
        downloadMovements() {
            window.open(this.globalUrlFiles + '/buildings/departments_pays');
        },
        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = this.search;
            search.search = this.name;
            let _endpoint = '/contracts';
            try {
                let { data } = await service.list(_endpoint, page, search)
                if (data) {
                    console.log(data);
                    this.buys = data;
                    this.load = false;
                    if (search.authorization_user_id != '' && search.authorization_status != '') {
                        this.getCountContractsDepartments();
                    }
                }
            } catch (error) {
                console.log(error);
                this.load = false;
            }
        },
        async getCountContractsDepartments() {
            this.loadCount = true;
            let service = request;
            let search = this.search;
            search.search = this.name;
            let _endpoint = '/catalogue/count_contracts?authorization_user_id=' + search.authorization_user_id + '&authorization_status=' + search.authorization_status + '&user_id_authorization=' + search.user_id_authorization;
            try {
                let { data } = await service.get(_endpoint);
                this.count1 = data.total_filtered;
                this.count2 = data.total_missing;
                this.loadCount = false;
            } catch (error) {
                console.log(error);
                this.loadCount = false;
            }
        },
        deleteContract: function (id) {
            let tit = 'Eliminar contrato';
            let txt = 'Seguro que quiere eliminar el contrato';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/contracts/' + id;
                    try {
                        let response = await request.destroy(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        execute_debts: function () {
            let tit = 'Generar adeudos';
            let txt = 'Seguro que quiere generar los adeudos';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Generar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/ejecutar-adeudos';
                    try {
                        let response = await request.get(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        downloadExcel() {
            let _url = this.globalUrlFiles + '/contract/report_excel';
            window.open(_url, '_blank');
        },
        signedContract: function (id) {
            let tit = 'Firmar contrato';
            let txt = 'Seguro que quiere firmar el contrato';
            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Firmar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/contracts/' + id + '/signed';
                    try {
                        let response = await request.post(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },

        reviewed: function (contract) {
            let tit = 'Autorizar contrato';
            let txt = 'Seguro que quiere autorizar el contrato';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Autorizar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/contracts_authorized?id=' + contract.id;
                    try {
                        let response = await request.post(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        changeStatus: function (buy) {
            Event.$emit('event-show-changeStatusContracts', buy);
        },
        currentPayments: function (buy) {
            Event.$emit('event-show-currentPayments', buy);
        },
        editBuy(buy = {}, edit = true) {
            this.editForm = edit;
            Event.$emit('event-show-addDepartamentUser', buy);
        },
        createFrom(buy) {
            this.editForm = true;
            Event.$emit('event-show-createFrom', buy);
        },
        createFromRenovation(buy) {
            this.editForm = true;
            Event.$emit('event-show-createFromRenovation', buy);
        },
        showPays(pay) {
            Event.$emit('event-show-tablePays', pay);
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.list();
        this.catalogue.get_buildings();
        this.catalogue.get_companies_all();
        this.catalogue.get_users_profile(7);
        // this.catalogue.get_count_contracts_departments();
    },
    created() {
        Event.$on("event-load-contracts", () => {
            this.list();
        });
    },
    watch: {
        "search": {
            handler: function () {
                this.list();
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}

</script>
<template>
    <div class="col-12">
        <ModalFormComponentContracts :prop_edit="editForm" />
        <ModalForm :prop_edit="editForm" />
        <ModalTablePays />
        <ModalContractEnds />
        <ModalFormCurrentPayments />
        <ModalTableContractsRelation />
        <ModalFormIncreases />
        <ModalFilesContractsComponent />
        <ModalContractEndsDetailComponent />
        <div class="card card-outline card-info">
            <div class="card-header">
                <h3 class="card-title">Lista de Contratos</h3>
                <div class="card-tools">
                    <button @click="showNewContracts()" v-can="'add_contracts'"
                        class="btn btn-sm mr-1 btn-outline-info">
                        <i class="fa fa-plus"></i> Contrato
                    </button>
                    <button @click="execute_debts()" v-can="'add_contracts'"
                        class="btn btn-sm mr-1 btn-outline-success">
                        <i class="fa-solid fa-money-bill-trend-up"></i> Generar adeudos
                    </button>
                    <button @click="downloadExcel()" class="btn btn-sm mr-1 btn-outline-info">
                        <i class="fa fa-file-excel"></i> Descargar Excel
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">

                    <div class="col-md-6">
                        <label>Propiedad :</label>
                        <select class="form-control" v-model="search.building_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="building.id" v-for="(building, index) in catalogue.buildings" :key="index">
                                {{ building.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Empresa :</label>
                        <select class="form-control" v-model="search.company_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="company.id" v-for="(company, index) in catalogue.companies_all"
                                :key="index">{{ company.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Estatus :</label>
                        <select class="form-control" v-model="search.finish" @change="list()">
                            <option value="">Todas</option>
                            <!-- <option value="1">Por terminar</option> -->
                            <!-- <option value="2">Por incrementar</option> -->
                            <option value="3">Falta porcentaje </option>
                            <option value="4">Vencido sin finalizar</option>
                            <option value="5">Falta firma</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label>Cliente :</label>
                        <select class="form-control" v-model="search.user_id" @change="list()">
                            <option value="">Todas</option>
                            <option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
                                :key="user_index">{{ user.name }} {{ user.last_name }}</option>
                        </select>
                    </div>
                    <div class="col-md-3" v-if="search.finish">
                        <label>Fecha :</label>
                        <select class="form-control" v-model="search.month" @change="list()">
                            <option value="">Todas</option>
                            <option value="1">Enero</option>
                            <option value="2">Febrero</option>
                            <option value="3">Marzo</option>
                            <option value="4">Abril</option>
                            <option value="5">Mayo</option>
                            <option value="6">Junio</option>
                            <option value="7">Julio</option>
                            <option value="8">Agosto</option>
                            <option value="9">Septiembre</option>
                            <option value="10">Octubre</option>
                            <option value="11">Noviembre</option>
                            <option value="12">Diciembre</option>
                        </select>
                    </div>
                    <div class="col-md-3" v-if="search.finish">
                        <label>Año :</label>
                        <select class="form-control" v-model="search.year" @change="list()">
                            <option value="">Todas</option>
                            <option v-for="year in years" :key="year" :value="year">{{ year }}</option>

                        </select>
                    </div>
                    <div class="col-md-10 mt-1"
                        v-if="authUser.organization_charts_id == 1 || authUser.organization_charts_id == 10 || authUser.organization_charts_id == 11">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Perfil de autorización :</label>
                                <select class="form-control" v-model="search.authorization_user_id"
                                    @change="getUserProfile()">
                                    <option value="">Todas</option>
                                    <option value="1">Administrador</option>
                                    <option value="10">Analista contable</option>
                                    <option value="11">Jurídico</option>
                                    <option value="100">Revisión conjunta</option>
                                </select>
                            </div>
                            <div class="col-md-4" v-if="search.authorization_user_id">
                                <label>Usuario :</label>
                                <select class="form-control" v-model="search.user_id_authorization" @change="list()">
                                    <option value="">Todas</option>
                                    <option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
                                        :key="user_index">{{ user.name }} {{ user.last_name }}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label>Estatus :</label>
                                <select class="form-control" v-model="search.authorization_status" @change="list()">
                                    <option value="">Todas</option>
                                    <option value="1">Autorizados</option>
                                    <option value="2">Faltan autorización</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mt-1"
                        v-if="search.authorization_user_id != '' && search.authorization_status != ''">
                        <label>Conteo :</label>
                        <h3><span class="badge bg-secondary">
                                <span v-if="loadCount">
                                    <i class="fa-solid fa-circle-notch fa-spin mb-1"></i>
                                </span>
                                <span v-else>
                                    {{ count1 }} / {{ count2 }}
                                </span>
                            </span></h3>
                    </div>
                </div>
                <br>
                <div class="row">

                    <div class="col-md-12">
                        <ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" @click="search.status = 1" data-toggle="pill" role="tab"
                                    aria-selected="true">Activos</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="search.status = 2" data-toggle="pill" role="tab"
                                    aria-selected="false">Terminados</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered text-center text-sm">
                        <thead>
                            <tr>
                                <th style="width: 50px;">ID</th>
                                <th style="width: 200px;">Datos del pago</th>
                                <th style="width: 100px;">Fecha</th>
                                <th style="width: 100px;">Monto</th>
                                <th style="width: 100px;">Servicios</th>
                                <th style="width: 100px;">Opciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="load">
                            <tr>
                                <td align="center" colspan="7">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="buys.data && buys.data.length > 0">
                            <tr :class="buy.authorization_user_id ? 'bg-info' : ''" v-for="(buy, index) in buys.data"
                                :key="index">
                                <td>
                                    {{ buy.id }}

                                    <i class="fa-solid fa-star text-warning"
                                        v-if="buy.user_admin.length > 0 && buy.user_juridical.length > 0 && buy.user_auxiliary.length > 0"></i>
                                </td>
                                <td class="text-left">

                                    <strong>Propiedad:</strong>
                                    <span v-if="buy.building">
                                        {{ buy.building.name }}
                                    </span>
                                    <span v-else>Sin propiedad</span>
                                    <br>

                                    <strong>Usuario:</strong>
                                    <span v-if="buy.user">
                                        {{ buy.user.name }} {{ buy.user.last_name }}
                                    </span>
                                    <span v-else>Sin usuario</span>
                                    <br>

                                    <!-- Recurrencia -->
                                    <strong>Recurrencia:</strong>
                                    <span v-if="buy.payment_period"> {{ buy.payment_period.name
                                    }}</span>
                                    <span v-else>Sin Recurrencia</span>
                                    <br>

                                    <!-- Fecha de registro -->
                                    <strong>Fecha de registro:</strong>
                                    <span>
                                        {{ buy.created_at | toDateTime }}
                                    </span>
                                    <br>

                                    <!-- Renta unica -->
                                    <strong>Renta única:</strong>
                                    <span v-if="buy.unique_rent == 1">
                                        Si
                                    </span>
                                    <span v-else>
                                        No
                                    </span>
                                    <br>

                                    <!-- Addendum -->
                                    <strong v-if="buy.all_parent_ids.length >= 1">Addendum:</strong><br
                                        v-if="buy.all_parent_ids.length >= 1">
                                    <a class="badge p-1 badge-info ml-1" v-show="buy.all_parent_ids.length >= 1"
                                        style="cursor: pointer;" @click="showAddendum(parent)"
                                        v-for="(parent, index) in buy.all_parent_ids" :key="index">
                                        Contrato # {{ parent }}
                                    </a>
                                    <br v-if="buy.all_parent_ids.length >= 1">

                                    <!-- Administrador -->
                                    <div v-if="buy.user_admin.length > 0">
                                        <strong>Administrador:</strong><br>
                                        <p class="badge p-1 badge-info mb-0" v-for="(admin, index) in buy.user_admin"
                                            :key="index">
                                            {{ admin.user?.name }} {{ admin.user?.last_name }}
                                        </p>
                                    </div>

                                    <!-- Juridical -->
                                    <div v-if="buy.user_juridical.length > 0">
                                        <strong>Jurídico:</strong><br>
                                        <p class="badge p-1 badge-info mb-0"
                                            v-for="(auxiliar, index) in buy.user_juridical" :key="index">
                                            {{ auxiliar.user?.name }} {{ auxiliar.user?.last_name }}
                                        </p>
                                        <br>
                                    </div>

                                    <!-- Auxiliar -->
                                    <div v-if="buy.user_auxiliary.length > 0">
                                        <strong>Analista Contable:</strong><br>
                                        <p class="badge p-1 badge-info mb-0"
                                            v-for="(juridical, index) in buy.user_auxiliary" :key="index">
                                            {{ juridical.user?.name }} {{ juridical.user?.last_name }}
                                        </p>
                                        <br>
                                    </div>

                                    <!-- Indivisos -->
                                    <strong>Indivisos:</strong><br>
                                    <span class="badge p-1 badge-success ml-1"
                                        v-for="(department, index) in buy.departments" :key="index">
                                        Piso {{ department.level }} / {{ department.number }} <span
                                            v-if="department.date"> - {{ department.date | toDateTime }}</span>
                                    </span>
                                    <br>

                                    <hr>

                                    <button @click="showNewContracts(buy, false)" type="button"
                                        class="btn btn-sm  m-1 btn-outline-secondary ">
                                        <i class="fa-solid fa-eye"></i> Ver
                                    </button>

                                    <button @click="showNewContracts(buy)" v-can="'edit_contracts'"
                                        v-if="buy.user_admin.length == 0 && buy.user_juridical.length == 0 && buy.user_auxiliary.length == 0"
                                        class="btn btn-outline-primary m-1 btn-sm">
                                        <i class="fas fa-edit "> </i> Editar
                                    </button>

                                    <button @click="deleteContract(buy.id)" v-can="'deleted_contracts'"
                                        class="btn btn-outline-danger m-1 btn-sm">
                                        <i class="fas fa-trash "> </i> Eliminar
                                    </button>

                                    <button @click="signedContract(buy.id)"
                                        v-if="buy.signed == 0 && [1, 11].includes(authUser.organization_charts_id)"
                                        class="btn btn-outline-primary m-1 btn-sm">
                                        <i class="fa-solid fa-file-contract"></i> Firmar contrato
                                    </button>

                                </td>
                                <td>
                                    <span v-if="buy.start_date"> {{ buy.start_date | toDateTime }} </span>
                                    <br>-<br>
                                    <span v-if="buy.end_date"> {{ buy.end_date | toDateTime }} </span>
                                    <span v-else> Sin fecha fin </span>

                                </td>
                                <td class="text-center">
                                    <!-- Renta única -->
                                    <div v-if="buy.unique_rent == 1 && buy.unique_rent_data">
                                        <span class="badge p-1 badge-success">Renta</span><br>
                                        {{ buy.unique_rent_data.subtotal | toCurrency }}
                                    </div>
                                    <div v-else-if="buy.departments">
                                        <div v-for="(department, index) in buy.departments" :key="index">
                                            <span class="badge p-1 badge-success ml-1"> Renta / Piso {{ department.level
                                            }} / {{ department.number }}</span><br>
                                            {{ department.subtotal_rent | toCurrency }}
                                        </div>
                                    </div>

                                    <!-- Depósito único -->
                                    <div v-if="buy.unique_deposit == 1 && buy.deposit_amount > 0">
                                        <span class="badge p-1 badge-info">Depósito</span><br>
                                        {{ buy.deposit_amount | toCurrency }}
                                    </div>
                                    <div v-else-if="buy.departments">
                                        <div v-for="(department, index) in buy.departments" :key="index"
                                            v-show="department.deposit > 0">
                                            <span class="badge p-1 badge-info ml-1">Depósito / Piso {{ department.level
                                            }} / {{ department.number }}</span><br>
                                            {{ department.deposit | toCurrency }}
                                        </div>
                                    </div>

                                </td>
                                <td class="text-center">
                                    <div v-if="buy.unique_services == 1">
                                        <div v-for="(service, index) in buy.unique_services_data" :key="index"
                                            v-show="service.include_rent == false && service.subtotal > 0">
                                            <span class="badge p-1 badge-success" v-if="service.service">{{
                                                service.service.name }}</span>
                                            <span class="badge p-1 badge-success" v-else>{{ service.service_name
                                            }}</span><br>
                                            {{ service.subtotal | toCurrency }}
                                        </div>
                                    </div>
                                    <div v-else-if="buy.departments">
                                        <div v-for="(department, index) in buy.departments" :key="index">
                                            <div v-for="(service, index_service) in department.services"
                                                :key="index_service"
                                                v-show="service.include_rent == false && service.subtotal > 0">
                                                <span class="badge p-1 badge-success">
                                                    <p class="mb-1">{{ service.name }}</p>
                                                    Piso {{ department.level }} / {{ department.number }}
                                                </span><br>
                                                {{ service.subtotal | toCurrency }}
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <button @click="changeStatus(buy)" v-can="'edit_contracts'" class="btn m-1 btn-sm"
                                        :class="buy.status == 1 ? 'btn-outline-danger' : 'btn-outline-success'">
                                        <i class="fa-solid fa-power-off"></i>
                                        <span v-if="buy.status == 1">
                                            Terminar
                                        </span>
                                        <span v-else>
                                            Activar
                                        </span>
                                    </button>

                                    <button @click="increase(buy)" v-can="'edit_contracts'" v-if="!buy.end_all"
                                        class="btn m-1 btn-sm btn-outline-secondary">
                                        <i class="fa-solid fa-money-bill-trend-up mr-1"></i>
                                        Aumento
                                        <span v-if="buy.increases_month_count > 0">
                                            <i class="fa-solid fa-triangle-exclamation fa-beat text-warning fa-fw"></i>
                                        </span>
                                    </button>

                                    <button @click="showFilesContracts(buy)" class="btn m-1 btn-sm btn-outline-primary">
                                        <i class="fa-solid fa-layer-group"></i>
                                        Evidencia
                                        <span class="badge bg-secondary">
                                            {{ buy.files_count }}
                                        </span>
                                    </button>

                                    <button @click="reviewed(buy, authUser.organization_charts_id)"
                                        v-if="shouldShowAuthorizeButton(buy) && !buy.end_all"
                                        class="btn m-1 btn-sm btn-outline-success">
                                        <i class="fa-solid fa-file-signature mr-1"></i>
                                        Autorizar
                                    </button>

                                    <button @click="renew(buy)" v-if="buy.children_contracts_count == 0 && !buy.end_all"
                                        v-can="'edit_contracts'" class="btn m-1 btn-sm btn-outline-warning">
                                        <i class="fa-solid fa-arrow-rotate-right mr-1"></i>
                                        Renovar
                                    </button>

                                    <button @click="addendum(buy)"
                                        v-if="buy.children_contracts_count == 0 && !buy.end_all"
                                        v-can="'edit_contracts'" class="btn m-1 btn-sm btn-outline-info">
                                        <i class="fa-solid fa-arrow-rotate-right mr-1"></i>
                                        addendum
                                    </button>

                                    <a type="button" target="_blank" class="btn m-1 btn-sm btn-outline-primary"
                                        :href="`${globalUrlFiles}/generar_history/${buy.id}`">
                                        <i class="fa-solid fa-file-lines fa-fw"></i>
                                        Historial de movimientos
                                    </a>

                                    <button @click="showEnds(buy)" v-if="buy.end_all"
                                        class="btn m-1 btn-sm btn-outline-secondary">
                                        <i class="fa-solid fa-file-lines fa-fw"></i>
                                        Detalles de termino
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td align="center" colspan="7">Sin resultados.</td>
                            </tr>
                        </tbody>

                    </table>
                    <pagination v-model="page" :records="buys.total" :per-page="buys.per_page" @paginate="list" />
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #ffffff;
    background-color: #214d83;
    border-color: #dee2e6 #dee2e6 #fff;
}

.selected {
    color: #000;
    font-weight: bold;
    animation: blinkingText 4s infinite;
}

.text-purple {
    color: #322348;
}
</style>